"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const Label = _ref => {
  let {
    prefix,
    label,
    reqText,
    htmlFor,
    className,
    ...otherProps
  } = _ref;
  return _react.default.createElement("label", _extends({
    htmlFor: htmlFor,
    className: className
  }, otherProps), label, reqText && _react.default.createElement("em", {
    className: "".concat(prefix, "required")
  }, " ", reqText));
};
Label.defaultProps = {
  label: 'Label',
  prefix: ''
};
var _default = Label;
exports.default = _default;